const classes = {
  class: "Classe",
  classes: "Classes",
  level: "Niveau",
  publication: "Publication",
  create: "Créer une nouvelle classe",
  follow: "Suivre mes classes",
  followed: "Suivi des classes",
  edit: "Modifier la classe",
  save: "Enregistrer la classe",
  hasNoClassWarning: "Vous n'avez aucune classe actuellement.",
  hasNoClassWithStudentStart: "Vous avez",
  hasNoClassWithStudentEnd:
    "classe(s) dont aucun élève n'a encore accédé à iizenglish. Les classes apparaîtront quand au moins un élève aura accédé à la plateforme.",
  deleteStudentQuestion: "Supprimer cet élève de la classe ?",
  deleteStudentDescription:
    "L'élève ne fera plus partie de cette classe. Après confirmation, l'action sera immédiate.",
  selectedClasses: "Classe(s) concernée(s)",
  atLeastOneSelectedClass: "Au moins une classe doit être sélectionnée.",
  searchSchoolHere: "Recherchez un établissement ici...",
  searchTeacherHere: "Recherchez un enseignant ici...",
  searchSchoolHelp:
    "Veuillez sélectionner un établissement dans la liste déroulante. Laissez le champ vide si vous n'êtes rattaché à aucun établissement.",
  removedTeacherClassHelp:
    "Sauvegardez la classe pour que les changements soient pris en compte.",
  searchClassHere: "Recherchez une classe ici...",
  languageHelp:
    "Sera utilisé pour définir la langue des mails envoyés à l'élève",
  addTeacherModalTitle: "Rejoindre une classe",
  addTeacherModalContent:
    "Vous vous apprêtez à rejoindre la classe {className} en tant que professeur. Êtes-vous sûr ?",
  newTeacher: "Nouvel enseignant",
  theWholeClass: "Toute la classe",
  theWholeClasses: "Toutes les classes",
  myClasses: "Mes classes",
  atLeastOneLevel: "Au moins un niveau doit être sélectionné.",
  deleteClassQuestionForTeacher:
    "Êtes-vous sûr de vouloir supprimer cette classe ? ",
  deleteClassWarning:
    "Une fois supprimée, la classe ne pourra plus être récupérée. Les devoirs qui ne sont assignés qu'à cette classe seront également supprimés.",
  className: "Nom de la classe",
  classCreation: "Création d'une classe",
  classEdition: "Édition d'une classe",
  notEditable: "Classe importée depuis votre ENT, elle n'est pas modifiable",
  addClass: "Ajouter une classe",
  classList: "Liste des classes",
  deleteClassQuestion: "Supprimer cette classe ?",
  deleteClass: "Supprimer la classe",
  deleteClassDescription:
    "L'ensemble des devoirs et notes associés seront définitivement perdus.",
};

export default classes;
